export default function (name) {
  if (name) {
    if (name.length >= 3) {
      return name[0] + "*".repeat(name.length - 2) + name[name.length - 1];
    }
    return name[0] + "*";
  }
  return "";
}
